module.exports = {"540525100":"曲松镇","540525101":"罗布沙镇","540525200":"邱多江乡","540525201":"堆随乡","540525202":"下江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540525.json
// module id = 2532
// module chunks = 0